
const CheckboxGroup = ({
  segMeds,
  label,
  onChange,
  cols2 = true,
  cols3 = false,
  semibold = true,
  isDisabled = false
}) => {
  return (
    <div className="rounded-lg border p-2 bg-white  text-base">
      <p className={`${semibold ? 'font-semibold' : 'font-medium'} mb-1`}>{label}</p>

      <div className={`grid ${cols3 ? 'grid-cols-3' : cols2 ? 'grid-cols-2' : 'grid-cols-1'} gap-2`}>
        {Object.keys(segMeds).map((med) => (
          <label
            key={med}
            className="flex items-center gap-2 cursor-pointer"
          >
            <input
              type="checkbox"
              checked={segMeds[med] === true}
              onChange={(e) => {
                if (isDisabled) return;
                onChange(med, e.target.checked ? true : null);
              }}
              disabled={isDisabled}
              className="accent-blue-600 border-2 border-gray-700"
            />
            <span>{med}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default CheckboxGroup;
